
    <div class="form-container">
        <div class="inline">
            <h4>Manage Partnerships</h4>
        </div>&nbsp; &nbsp;
        <div class="inline">
            <button pButton type="button" label="Add Partner" (click)="showAddDialog()"></button>
        </div>  
    </div>
    <br>
    <app-add-partnership [displayAddDialog] = displayAddDialog (onDialogClose) = "addDialogClose($event)" (onRelationships) = "refreshRelationships($event)" *ngIf="displayAddDialog" (onError)= errorMessage($event)></app-add-partnership>
    <app-partnership-list [relationships] = "relationships" [messages]="this.messages"></app-partnership-list>
    

